<template>
  <div class="magicNav"  id="magicNav">
    <div class="tabs" v-show="!showAllType">
      <ul>
        <li :class="{'selected':sensorType == item.name}" v-for="(item,index) in typeList" @click="monitorTypeClick(item.name,item.ename)" :key="index">
          <img v-show="sensorType != item.name" :src="'static/imgs/g' + item.name + '.png'" />
          <img v-show="sensorType == item.name" :src="'static/imgs/' + item.name + '.png'" />
          <div class="text" v-html="item.ename"></div>
        </li>
      </ul>
      <div class="navBtn" v-show="navShow" v-if="typeListAll.length >8">
        <a :class="{'light':nowCount == index}" v-for="index in navCount" href="#" @click.stop="changeTypePage(index)" :key="index"></a>
      </div>
    </div>
    <div class="simples" v-show="showAllType">
      <p>
        <img :src="'static/imgs/' + sensorType + '.png'" />
        <span class="text" v-html="sensorName"></span>
      </p>
    </div>
    <div class="iconBtn">
      <span class="down">
          <Icon type="arrow-down-c"  @click="showTable()" v-if="showAllType" class="showIcon"></Icon>
      </span>
      <span class="up">
          <Icon type="arrow-up-c" @click="showTable()" v-if="!showAllType" class="showIcon"></Icon>
      </span>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        userConfig: {},
        typeListAll:[],
        typeList:[],
        nowCount:1,
        navCount:0,
        navShow:true,
        sensorType: '',
        sensorName:'',
        showAllType: false
      };
    },
    methods: {
      getType() {
        this.$http.get(this.userConfig.apiName + '/v4/' + this.userConfig.differentApi.sensorType).then(response=>{
          if(response.data.code == 0){
            let result = response.data.data;
            if(result){
              this.$set(this,'typeListAll',result);
              this.sensorType = result[0].name;
              this.sensorName = result[0].ename;
              this.monitorTypeClick(this.sensorType,this.sensorName);
              for(let i = 0; i < 8; i++){
                if(result[i]){
                  this.typeList.push(result[i]);
                }
              }
              this.navCount = Math.ceil(result.length/8);
            }

          }
        })
      },
      monitorTypeClick(sensorType,type) {
        this.$set(this,'sensorType',sensorType);
        this.$set(this,'sensorName',type);
        this.$root.sensorTypeHub.$emit("sensorType", sensorType);
      },
      showTable() {
        this.$set(this, "showAllType", !this.showAllType);
      },
      changeTypePage(index){
        this.nowCount = index;
        let arr = [];
        for(let i = (index-1)*8 ; i < 8*index;i++){
          if(this.typeListAll[i]){
            arr.push(this.typeListAll[i]);
          }
        }
        this.$set(this,'typeList',arr);
      }
    },
    mounted() {
      this.$set(this,"userConfig",JSON.parse(window.sessionStorage.getItem("userConfig")));
      if(this.userConfig){
        this.getType();
      }
    }
  };
</script>

<style scoped lang="less">
  .scales{
    height: 90px;
  }
  .magicNav {
    position: fixed;
    top: 1.3rem;
    left: 0px;
    z-index: 20;
    border-radius: 0.1rem;
    -moz-user-select: -moz-none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;

    .tabs{
      width: 350px;
      // height: 80px;
      border-radius: 0.1rem;
      border: 1px solid #06907b;
      background: #081623;
      opacity: 0.9;
      overflow: hidden;
      padding: 5px;
      position: relative;
      ul {
        // overflow: hidden;
        li {
          width: 25%;
          height: 70px;
          padding: 10px 0;
          box-sizing: border-box;
          float: left;
          .text {
            line-height: 40px;
            color: #f1f1f1;
          }
          img{
            width: 0.4rem;
          }
        }
        .selected {
          .text {
            color: #0bfcd7;
          }
        }
      }
      .navBtn {
        width: 100%;
        height: 20px;
        position: absolute;
        bottom: 0;
        a {
          display: inline-block;
          width: 10px;
          height: 10px;
          margin: 0 5px;
          background: #fff;
        }
        .light {
          background: #0bfcd7;
        }
      }
    }
    .simples {
      width: 80px;
      height: 90px;
      border-radius: 0.1rem;
      border: 1px solid #06907b;
      background: #081623;
      opacity: 0.9;
      p {
        width: 80px;
        height: 90px;
        padding: 10px 0;
        box-sizing: border-box;
        float: left;
        .text {
          display: block;
          line-height: 40px;
          color: #0bfcd7;
        }
        img{
          width: 0.4rem;
        }
      }
    }
    .iconBtn{
      position: absolute;
      right: 10px;
      bottom: 0;
      z-index: 9;
    }
    .down{
      *{
        transform: rotate(-45deg);
        vertical-align: sub;
        color: #0bfcd7;
      }
    }
    .up {
      * {
        transform: rotate(-45deg);
        vertical-align: sub;
        color: #0bfcd7;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/main/magicNav.vue